import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { fetchWithRetry } from '../../util/sliceUtils';

const backendUrl = process.env.REACT_APP_BackendUrl;

const TUNNEL_URL = backendUrl + '/tunnelStatus';

export const tunnelStateSlice = createSlice({
    name: 'tunnelState',
    initialState: {
        tunnelState: {},
        tunnelStateLoading: false,
        tunnelStateFailed: false,
        retryCount: 0,
    },
    reducers: {
        setTunnelState: (state, action) => {
            state.tunnelState = action.payload;
            state.retryCount = 0;
        },
        setTunnelStateLoading: (state, action) => {
            state.tunnelStateLoading = action.payload;
        },
        setTunnelStateFailed: (state, action) => {
            state.tunnelStateFailed = action.payload;
        },
        incrementRetryCount: (state) => {
            state.retryCount += 1;
        },
        resetRetryCount: (state) => {
            state.retryCount = 0;
        },
    },
});

export const {
    setTunnelState, setTunnelStateLoading, setTunnelStateFailed,
    incrementRetryCount, resetRetryCount,
} = tunnelStateSlice.actions;

export const getTunnelState = (forceRetry = false) => {
    return fetchWithRetry({
        fetchFn: () => axios.get(`${TUNNEL_URL}`, { headers: {} }),
        actions: {
            setData: setTunnelState,
            setLoading: setTunnelStateLoading,
            setFailed: setTunnelStateFailed,
            incrementRetry: incrementRetryCount,
        },
        selectors: {
            selectRetryCount: selectRetryCount,
            selectLoading: selectTunnelStateLoading,
        },
        retryActionName: 'RETRY_TUNNEL_STATE',
        errorMessagePrefix: 'Failed to load tunnel status',
        retryThunk: getTunnelState,
    }, forceRetry);
};

// Retry thunk for manual retry from toast
export const retryTunnelState = () => (dispatch) => {
    console.log('Manually retrying tunnel state...');
    dispatch(resetRetryCount());
    dispatch(getTunnelState(true));
};

export const selectTunnelState = state => state.tunnelState.tunnelState;
export const selectTunnelStateLoading = state => state.tunnelState.tunnelStateLoading;
export const selectTunnelStateFailed = state => state.tunnelState.tunnelStateFailed;
export const selectRetryCount = state => state.tunnelState.retryCount;

export default tunnelStateSlice.reducer;
